import { Injectable, ComponentRef, Provider } from '@angular/core';
import { IUserInformationSetDialogService, IUserInformationSetDialogServiceToken } from 'shared/services/ui/dialogs/user-information-set-dialog/user-information-set-dialog-service.abstract';
import { UserDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { UserInformationSetDialogMHComponent } from '../../components/shared/user/information-set-dialog/user-information-set-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class UserInformationSetDialogService implements IUserInformationSetDialogService {

  userInformationSetDialogShow(
    modalTitle: string,
    callbackSubmit: () => void,
    callbackCancel: () => void,
    user: UserDto,
    submitButtonLabel?: string,
    cancelButtonLabel?: string,
  ) {
    DialogBaseService.dialogGenericShow(
      UserInformationSetDialogMHComponent,
      (component: ComponentRef<UserInformationSetDialogMHComponent>) => {
        component.instance.modalTitle = modalTitle;
        component.instance.user = user;
        if (submitButtonLabel) {
          component.instance.submitButtonLabel = submitButtonLabel;
        }
        if (cancelButtonLabel) {
          component.instance.cancelButtonLabel = cancelButtonLabel;
        }

        component.instance.modalSubmit.subscribe(
          () => {
            callbackSubmit();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}
/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const UserInformationSetDialogServiceProvider: Provider[] = [
  { provide: IUserInformationSetDialogServiceToken, useExisting: UserInformationSetDialogService }
];


